import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { SearchCustomerIndexDataSelector } from './SearchCustomerIndexDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { SearchCustomerIndexResponse } from '@cp-shared-19/apis';
import { fetchSearchCustomerIndex } from './SearchCustomerIndexSlice';

export function useSearchCustomerIndex(): AbstractDataState<
    SearchCustomerIndexResponse,
    DefaultBusinessMarketApiErrorCode
> {
    return useGetSimpleApiData(fetchSearchCustomerIndex, SearchCustomerIndexDataSelector, true);
}
